import { type HttpClient } from "silver";
import { type MyonApiResponse, isMyonApiSuccess } from "shared/Api/MyonApiResponse";

export type LoginBuildingSearchResult = {
	id: number;
	building: string;
	account: string;
	message: string | null;
	allowLogin: boolean;
	host?: string;
};

const PARAM_BUILDING_SEARCH = "search";
const PARAM_PRIORITIZE_HOST = "host";
export class LoginBuildingSearchService {

	constructor(
		private httpClient: HttpClient,
		private searchUrl: string,
		private prioritizeHost: string | null,
	) {}

	public async search(text: string): Promise<LoginBuildingSearchResult[]> {
		const response: MyonApiResponse<LoginBuildingSearchResult[], null> = await this.httpClient.get(
			this.searchUrl,
			{
				query: {
					[PARAM_BUILDING_SEARCH]: text,
					[PARAM_PRIORITIZE_HOST]: this.prioritizeHost,
				}
			}
		);
		if (!isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Failed to search for building");
		}
		return response.result;
	}
}
